import { gql } from "@outschool/ui-apollo";

import { MessageContentWithMentionsFragment } from "./MessageContentFragment";
import { MessageSenderFragment } from "./MessageSenderFragment";

export default gql`
  fragment ClassPostFragment on ClassPost {
    uid
    isWelcomePost
    sender {
      ...MessageSenderFragment
    }
    messageContent {
      ...MessageContentWithMentionsFragment
    }
    publishAt
  }
  ${MessageSenderFragment}
  ${MessageContentWithMentionsFragment}
`;
